import React, { createContext, ReactNode, useContext, useMemo } from 'react';

import useInstallerBrand from '../hooks/useInstallerBrand';

interface BrandProviderProps {
  children: ReactNode;
  onError?: (e: unknown) => void;
}

type BrandContextType = ReturnType<typeof useInstallerBrand>;

export const BrandContext = createContext<BrandContextType | undefined>(undefined);

export const BrandProvider: React.FC<BrandProviderProps> = ({ children, onError }) => {
  const brand = useInstallerBrand({ onError });
  const { domainPrefix, installerId, brandResolving } = brand;
  const value = useMemo(
    () => ({ domainPrefix, installerId, brandResolving }),
    [domainPrefix, installerId, brandResolving]
  );
  return <BrandContext.Provider value={value}>{children}</BrandContext.Provider>;
};

export function useBrand(): BrandContextType {
  const ctx = useContext(BrandContext);
  if (!ctx) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return ctx;
}
